import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { HeaderList, IHeaderListActions, } from "../../Components/Header/HeaderList";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import WSButton from "../../Components/Button/WSButton";
export const VendorType: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const id = params?.id;


   useEffect(() => {
          breadCrumbsStore.updateBreadCrumbs([
              { 'Vendor Types': 'vendortype/list' },
              { [!id ? 'Add Vendor Types' : 'Update Vendor Types']: '/' },
          ]);
      }, [id]);

      
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getVendorTypeById(id: any) {
      try {
        const response: any = await callAPI(
          "VendorTypeMaster",
          Method.GET,
          {},
          id
        );

        if (response && response?.data) {
          setValue("typeName", response.data?.typeName);

          setValue("id", response.data?.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getVendorTypeById(id);
    }
  }, [id, setValue]);

  // /**
  //  * Method for Add/Update the data
  //  * @param data
  //  */

  const handleDataSaveAndNew = async (data: any) => {
    try {
      setLoadingSaveAndNew(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          reset();
        }
      } else if (response?.id) {
        reset();
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoadingSaveAndNew(false);
    }
  };
  const handleData = async (data: any) => {
    try {
      setLoading(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          navigate(`/vendortype/list`);
        }
      } else if (response?.id) {
        showMessage("Vendortype Created Successfully", "success");
        navigate(`/vendortype/list`);
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };

  const saveData = async (data: any) => {
    const request: any = {
      typeName: data?.typeName || "",
    };
    if (data?.vendortypeId) {
      const response: any = await callAPI(
        "VendorTypeMaster",
        Method.PUT,
        request,
        data.vendortypeId
      );
      return response;
    } else {
      const response: any = await callAPI(
        "VendorTypeMaster",
        Method.POST,
        request
      );
      return response;
    }
  };

  const handleCancelClick = () => {
    navigate("/vendortype/list");
  };
  const actions: IHeaderListActions[] = [
    {
      type: "button",
      text: "Cancel",
      size: "medium",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "primary",
    },
    {
      type: "button",
      text: "Save & New",
      loading: loadingSaveAndNew,
      size: "medium",
      onClick: handleSubmit(handleDataSaveAndNew),
      buttonType: "button",
      variant: "outlined",
      color: "primary",
    },
    {
      type: "button",
      text: "Save",
      loading: loading,
      size: "medium",
      onClick: handleSubmit(handleData),
      buttonType: "submit",
      variant: "outlined",
      color: "primary",
    },
  ];
  return (
    <Grid p={3}>
      <form onSubmit={handleSubmit(handleData)}>
        {/* <Grid item xs={12}>
          <HeaderList
            title="Vendor Type"
            type="card"
            position="relative"
            actions={actions}
            isBackButton={true}
            url="/vendortype/list"
          />
        </Grid> */}
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <WSTextField
                label={"Vendor Type"}
                {...register("typeName")}
                id="typeName"
                name="typeName"
                control={control}
                rules={{ required: true }}
              />
              <WSHiddenField
                control={control}
                name="vendortypeId"
                defaultValue={id}
              />
            </Grid>
          </Grid>
          </Grid>
           <Grid
        container
        justifyContent="flex-end"
        spacing={2} 
        sx={{ mt: 2 }}
      >
        <Grid item>
          <WSButton
            id="cancel"
            type="button"
            label="Cancel"
            size="medium"
            onClick={handleCancelClick}
            variant="outlined"
            color="primary"
            sx={{
              borderRadius: 8,
              width: "8rem",
              border: "1px solid #098963",
              color: "#098963",
              backgroundColor: "#FFFFFF",
            }}
          />
        </Grid>
        <Grid item>
          <WSButton
            id="submit"
            type="submit"
            label="Save & New"
            size="medium"
            variant="outlined"
            color="primary"
            loading={loadingSaveAndNew}
            onClick={handleSubmit(handleDataSaveAndNew)}
            sx={{
              borderRadius: 8,
              width: "8rem",
              border: "1px solid #098963",
              color: "#FFFFFF",
              backgroundColor: "#098963",
              "&:hover": {
                backgroundColor: "#066e4f",
              },
            }}
          />
        </Grid>

        <Grid item>
          <WSButton
            id="submit"
            type="submit"
            label="Save"
            size="medium"
            variant="outlined"
            color="primary"
            onClick={handleSubmit(handleData)}
            loading={loading}
            sx={{
              borderRadius: 8,
              width: "8rem",
              border: "1px solid #098963",
              color: "#FFFFFF",
              backgroundColor: "#098963",
              "&:hover": {
                backgroundColor: "#066e4f",
              },
            }}
          />
        </Grid>
      </Grid>
      </form>
    </Grid>
  );
});
